import {TFocusableEventType} from '../../Events/Constants/FocusableEventType';
import FocusableEvent from '../../Events/FocusableEvent';

type TEventListener = (event: FocusableEvent) => void;

class EventTarget<T extends TFocusableEventType> {
    private listeners: {[type: string]: TEventListener[]} = {};

    constructor() {
        this.addEventListener = this.addEventListener.bind(this);
        this.dispatchEvent = this.dispatchEvent.bind(this);
        this.removeEventListener = this.removeEventListener.bind(this);
    }

    public addEventListener(type: T | string, listener: TEventListener): void {
        const listenersOfType = this.listeners[type];

        if (typeof listenersOfType === 'undefined') {
            this.listeners[type] = [listener];

            return;
        }

        listenersOfType.push(listener);
    }

    public removeEventListener(type: string, listener: TEventListener): void {
        const listenersOfType = this.listeners[type];

        if (typeof listenersOfType === 'undefined') return;

        listenersOfType.splice(listenersOfType.indexOf(listener), 1);
    }

    public dispatchEvent(event: FocusableEvent): boolean {
        const {type} = event;

        const listenersOfType = this.listeners[type] || [];

        listenersOfType.forEach(listener => listener(event));

        return false;
    }
}

export default EventTarget;
